import { ActionStatus } from 'thunkless';
import produce from 'immer';
import * as _ from 'lodash';

import { SettingsTypes } from '../actions/settings';
import type { AppAction } from '../actions';

export interface UserSettings {
  embeddedVarsEnabled: boolean;
  templateHotkeysEnabled: boolean;
  spellcheckEnabled: boolean;
  quickChatEnabled: boolean;
  quickChatValue: string;
  showAvoNotes: boolean;

  pauseInbox: boolean;
  inboxTogglePauseStatus: ActionStatus;
  compactTickets: boolean;
  inboxToggleCompactModeStatus: ActionStatus;
}

export interface AccountSettings {
  hidePauseButton: boolean;
  privateTickets: boolean;
  noPrivateManager: boolean;
  onlyOwnedTickets: boolean;
}

export interface SettingsState {
  user: UserSettings;
  account: AccountSettings;
}

export const initialState: SettingsState = {
  user: null,
  account: null,
};

const toggle = (value: boolean) => !value;
export const reducer = produce((state: SettingsState, action: AppAction) => {
  switch (action.type) {
    case SettingsTypes.SET_SETTINGS: {
      Object.assign(state, action.payload);
      break;
    }

    case SettingsTypes.TOGGLE_PAUSE_INBOX_REQUEST: {
      state.user.inboxTogglePauseStatus = ActionStatus.BUSY;
      _.update(state, ['user', 'pauseInbox'], toggle);
      break;
    }

    case SettingsTypes.TOGGLE_PAUSE_INBOX_SUCCESS: {
      state.user.inboxTogglePauseStatus = ActionStatus.SUCCESS;
      break;
    }

    case SettingsTypes.TOGGLE_PAUSE_INBOX_FAILURE: {
      state.user.inboxTogglePauseStatus = ActionStatus.FAILURE;
      _.update(state, ['user', 'pauseInbox'], toggle);
      break;
    }

    case SettingsTypes.TOGGLE_INBOX_COMPACT_MODE_REQUEST: {
      state.user.inboxToggleCompactModeStatus = ActionStatus.BUSY;
      _.update(state, ['user', 'compactTickets'], toggle);
      break;
    }

    case SettingsTypes.TOGGLE_INBOX_COMPACT_MODE_SUCCESS: {
      state.user.inboxToggleCompactModeStatus = ActionStatus.SUCCESS;
      break;
    }

    case SettingsTypes.TOGGLE_INBOX_COMPACT_MODE_FAILURE: {
      state.user.inboxToggleCompactModeStatus = ActionStatus.FAILURE;
      _.update(state, ['user', 'compactTickets'], toggle);
      break;
    }
  }
}, initialState);
